import React from 'react';

export default function Logo(props) {
    return <img src="/logo.svg" height={22} {...props} />
}